module.exports = __webpack_public_path__ + "static/media/corporate-services-img39.2ed1de00.jpg";